import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { consume } from '@lit/context';
import { authContext, AuthState } from '../context/AuthContext';

@customElement('app-header')
export class AppHeader extends LitElement {
  createRenderRoot() { return this }
  @state() user = null;
  @state() showCreateChannel = false;
  @state() showMobileMenu = false;

  @consume({ context: authContext, subscribe: true })
  @property({attribute: false})
  public auth!: AuthState;

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  async checkAuthOrPrompt() {
    if (!this.auth.userId) {
      this.dispatchEvent(new CustomEvent('open-auth-modal', { bubbles: true, composed: true }));
      return false;
    }
    return true;
  }

  async handleCreateChannel() {
    if (!(await this.checkAuthOrPrompt())) return;
    this.showCreateChannel = true
    this.requestUpdate();
  }

  render() {
    const me = html`
      <div class="w-16 h-16 rounded-full overflow-hidden ring ring-primary ring-offset-base-100 ring-offset-2">
        <img src="${this.auth.user?.avatar_url || '/static/images/default-avatar.webp'}" alt="Me" />
      </div>
    `

    return html`
      <div class="sticky top-0 bg-base-300 z-50 shadow-sm px-4 py-3">
        <div class="flex justify-between items-center">
          <a href="/" class="flex items-center gap-2">
            <img src="/static/images/logo-sm.webp" alt="Logo" class="w-32" />
          </a>

          <button class="sm:hidden btn btn-ghost btn-sm" @click=${() => this.showMobileMenu = !this.showMobileMenu}>
            ☰
          </button>

          <div class="hidden sm:flex flex-1 justify-center">
            <search-bar></search-bar>
          </div>

          <div class="hidden sm:flex items-center gap-4">
            <button class="btn btn-sm btn-ghost plausible-event-name=header-create-channel-click text-lg" @click=${() => this.handleCreateChannel()}>➕ New Channel</button>
            <a href="/tools" target="_blank" class="btn btn-sm btn-ghost text-lg">✨ Create Content</a>
            ${this.auth.userId ? html`
              <a href="/me" class="plausible-event-name=header-me-authed-click">${me}</a>
            ` : html`
              <button class="btn btn-accent btn-outline plausible-event-name=header-me-unauthed-click" @click=${() => this.dispatchEvent(new CustomEvent('open-auth-modal', { bubbles: true, composed: true }))}>
                Sign In
              </button>
            `}
          </div>
        </div>

        ${this.showMobileMenu ? html`
          <div class="flex flex-col gap-3 mt-4 sm:hidden">
            <search-bar></search-bar>
            <button class="btn btn-sm btn-ghost plausible-event-name=header-create-channel-click" @click=${() => this.handleCreateChannel()}>➕ New Channel</button>
            <a href="/tools" target="_blank" class="btn btn-sm btn-ghost">✨ Create Content</a>
            ${this.auth.userId ? html`
              <a href="/me" class="flex items-center gap-2 plausible-event-name=header-me-authed-click">${me}<span>Profile</span></a>
            ` : html`
              <button class="btn btn-accent btn-outline plausible-event-name=header-me-unauthed-click" @click=${() => this.dispatchEvent(new CustomEvent('open-auth-modal', { bubbles: true, composed: true }))}>
                Sign In
              </button>
            `}
          </div>
        ` : null}

      </div>
      <create-channel-modal .open=${this.showCreateChannel} @close=${() => this.showCreateChannel = false}></create-channel-modal>
    `;
  }
}
